import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  config: any;

  constructor(private http: HttpClient) {}

  async loadConfig() {
    try {
      const config = await firstValueFrom(this.http.get('./assets/config.json'));
      this.config = config;
      environment.production = this.config['production'];
      environment.url = this.config['url'];
    } catch (error) {
      console.error('Error loading config.json', error);
    }
  }
}
